/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {CrashObject} from "../model/CrashObject";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class CrashObjectDefinitionService {

  private readonly baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/crashobjectdefinitions';
  }


  getAll(): Observable<CrashObject[]> {
    const url = `${this.baseUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(crashObject => crashObject as CrashObject[]));
  }

  updateCrashObjectById(crashObject: CrashObject): Observable<CrashObject>{
    const id = crashObject.crashObjectDefinitionId;
    const url = `${this.baseUrl}/${id}`;

    return this.http.put(url,crashObject,httpOptions).pipe(
      map(crashObject => crashObject as CrashObject));
  }

  addCrashObject(crashObject: CrashObject): Observable<CrashObject>{
    const url = `${this.baseUrl}`;

    return this.http.post(url,crashObject,httpOptions).pipe(
      map(crashObject => crashObject as CrashObject));
  }
}

